import { useContext } from "react";
import EarthNavbarContext from "../contexts/EarthNavbarContext";

const useEarthNavbarHook = () => useContext(EarthNavbarContext);

export default useEarthNavbarHook;
